import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCharacter } from '../context/CharacterContext';
import CharacterIntroModal from '../components/character/CharacterIntroModal';

// The imports for the custom Button and ImageWithFallback components have been removed.

export default function LandingPage() {
  const navigate = useNavigate();
  const { 
    hasWatchedIntro, 
    showIntroModal, 
    showCharacterIntro, 
    completeCharacterIntro 
  } = useCharacter();

  const handleStartJourney = () => {
    if (!hasWatchedIntro) {
      // Show character introduction first
      showCharacterIntro();
    } else {
      // Go directly to dashboard
      navigate('/dashboard');
    }
  };

  const handleIntroComplete = () => {
    completeCharacterIntro();
    navigate('/dashboard');
  };

  const buttonBaseClasses = "w-64 py-3 rounded-lg border border-white/30 bg-black/20 text-white/80 backdrop-blur-sm transition-all duration-300 ease-in-out focus:outline-none shadow-[0_0_5px_#0ff,0_0_15px_#0ff,0_0_25px_#0ff]";
  const neonHoverEffect = "hover:text-white hover:border-cyan-400 hover:shadow-[0_0_5px_#f0f,0_0_15px_#f0f,0_0_25px_#f0f]";

  return (
    // The `justify-end` class is added here to push its content (the button section) to the right.
    <div className="flex justify-end min-h-screen w-full bg-black text-white">
      {/* Background Image: Replaced <ImageWithFallback> with a standard <img> tag */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/landing_page.gif"
          alt="Futuristic landscape"
          className="h-full w-full object-cover" // object-cover ensures the image fills the container without distortion
        />
      </div>

      {/* Right Section: Content and Buttons */}
      {/* This section now renders on the right side of the page. */}
      <div className="w-full md:w-1/2 flex flex-col items-center justify-center p-8">
        <div className="flex flex-col items-center gap-12">
          {/* Button 1: View Achievements */}
          <button
            className={`${buttonBaseClasses} ${neonHoverEffect}`}
            onClick={() => navigate('/achievements')}
          >
            <span className="text-md font-semibold tracking-wider">
              View Achievements
            </span>
          </button>
          
          {/* Button 2: Start Journey */}
          <button
            onClick={handleStartJourney}
            className={`${buttonBaseClasses} ${neonHoverEffect}`}
          >
            <span className="text-md font-semibold tracking-wider">
              Start Journey
            </span>
          </button>
        </div>
      </div>

      {/* Character Introduction Modal */}
      <CharacterIntroModal
        isOpen={showIntroModal}
        onClose={() => navigate('/dashboard')}
        onComplete={handleIntroComplete}
        hasWatchedBefore={hasWatchedIntro}
      />
    </div>
  );
}